export const infoText = '<span>Complete the constellation by adding <b>synonyms</b></span>';